export default {
  DAYS: 'days',
  PRICE: 'price',
  FREE: 'free',
  PREMIUM: 'premium',
  DIRECT_SALE_DISCOUNT: 34,
};
